import { useOne } from '@refinedev/core';
import { EntityWithFieldMetadata } from 'src/UI/dynamicUI/types';

type Props = {
  id: string;
  entityType: string;
  clientId: string;
};

export const useEntity = ({ id, clientId, entityType }: Props) => {
  const { data, isLoading, isFetching, isError, error, refetch } = useOne<EntityWithFieldMetadata>({
    resource: `clients/${clientId}/${entityType}/entities`,
    id,
    queryOptions: {
      enabled: !!id && !!clientId && !!entityType,
    },
  });

  return {
    entityData: data?.data,
    isLoading: isLoading || isFetching,
    isError,
    refetch,
    error,
  };
};
